const validateCeaEmail = (email) => {
  const regexRule = "[a-z0-9]+@cea3+.[a-z]{2,3}";
  const regexString = new RegExp(regexRule);

  return regexString.test(email);
};

export default validateCeaEmail;
